import { isReserved } from "./reservedSlugs.js";

// Must match firestore.rules validSlug(): 3–40 chars, lowercase alnum + hyphen,
// no leading/trailing hyphen.
const SLUG_RE = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;

export function normalizeSlug(input = "") {
  return input
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function cleanSlugInput(input = "") {
  const lower = input.toLowerCase();
  const spaced = lower.replace(/\s+/g, "-");
  const cleaned = spaced
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+/, "");

  const changes = [];
  if (spaced !== lower) changes.push("Spaces become hyphens.");
  if (cleaned !== spaced) changes.push("Only letters, numbers and hyphens can be used.");

  return {
    slug: cleaned,
    warning: changes.length ? changes.join(" ") : "",
  };
}

export function validateSlug(slug) {
  if (!slug) return { ok: false, reason: "Enter a name for your link." };
  if (slug.length < 3) return { ok: false, reason: "Too short (min 3 characters)." };
  if (slug.length > 40) return { ok: false, reason: "Too long (max 40 characters)." };
  if (!SLUG_RE.test(slug)) return { ok: false, reason: "Use letters, numbers and hyphens only." };
  if (isReserved(slug)) return { ok: false, reason: "That name is reserved." };
  return { ok: true };
}
